module.exports = __webpack_public_path__ + "static/media/account-unlogged.38c05df8.svg";